// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * smapi-ticketing-api
 * The SBB Swiss Mobility API - Ticketing is an interface that you can integrate into your own distribution system. Fare details are made available to you via this interface. There are two ways to use the service:  - Either integrate the SBB Swiss Mobility API as a full version, so that bookings are made directly via your distribution environment - Or use the Affiliate solution, with a link to the SBB webshop or SBB mobile  Before you request access to our API, please get in contact with SBB Digital Affiliates by sending an email stating your intentions and goal. Please note that the purpose of our API is to generate sales turnover through it. Offers only is not permitted due to the Look2Book Ratio. Please check out our GTC as well. On the right you can find the contact details and the links to the important websites.  IMPORTANT: The journey endpoints `Locations` and `Trips` will be deprecated by October 31, 2024 and are planned to be removed in December 2024. Please switch to the new endpoints `/v1/places`, `/v1/trips-collection` and `/v1/trips/{tripId}` of the new [SBB Swiss Mobility Journey API](https://developer-int.sbb.ch/apis/smapi-osdm-journey/information). 
 *
 * The version of the OpenAPI document: latest
 * Contact: digitalsales@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The prices request.
 * @export
 * @interface TripPricesRequest
 */
export interface TripPricesRequest {
    /**
     * An array of passengers each of which contains id, age and reduction separated by a semicolon. (Can be multiple)
     * @type {Array<string>}
     * @memberof TripPricesRequest
     */
    passengers: Array<TripPricesRequestPassengersEnum>;
    /**
     * The desired product id for the prices.
     * @type {number}
     * @memberof TripPricesRequest
     */
    productId?: number;
    /**
     * The quality of service of the travel: 1, 2.
     * @type {number}
     * @memberof TripPricesRequest
     */
    qualityOfService?: number;
    /**
     * The tripId for this journey. It is the Base64 encoded HAFAS reconstruction context. The tripId can also be retrieved with the trips service.
     * @type {Array<string>}
     * @memberof TripPricesRequest
     */
    tripIds: Array<string>;
}


/**
 * @export
 */
export const TripPricesRequestPassengersEnum = {
    Ga1st: 'ga-1st',
    Ga2nd: 'ga-2nd',
    HalfFare: 'half-fare',
    JuniorCard: 'junior-card',
    ChildCard: 'child-card',
    None: 'none',
    SwissHalfFareCard: 'swiss-half-fare-card',
    SwissTravelPass: 'swiss-travel-pass'
} as const;
export type TripPricesRequestPassengersEnum = typeof TripPricesRequestPassengersEnum[keyof typeof TripPricesRequestPassengersEnum];


/**
 * Check if a given object implements the TripPricesRequest interface.
 */
export function instanceOfTripPricesRequest(value: object): value is TripPricesRequest {
    if (!('passengers' in value) || value['passengers'] === undefined) return false;
    if (!('tripIds' in value) || value['tripIds'] === undefined) return false;
    return true;
}

export function TripPricesRequestFromJSON(json: any): TripPricesRequest {
    return TripPricesRequestFromJSONTyped(json, false);
}

export function TripPricesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripPricesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'passengers': json['passengers'],
        'productId': json['productId'] == null ? undefined : json['productId'],
        'qualityOfService': json['qualityOfService'] == null ? undefined : json['qualityOfService'],
        'tripIds': json['tripIds'],
    };
}

  export function TripPricesRequestToJSON(json: any): TripPricesRequest {
      return TripPricesRequestToJSONTyped(json, false);
  }

  export function TripPricesRequestToJSONTyped(value?: TripPricesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'passengers': value['passengers'],
        'productId': value['productId'],
        'qualityOfService': value['qualityOfService'],
        'tripIds': value['tripIds'],
    };
}

